import React from "react";
import Payersolution from "../../components/accrodion/payersolution";

const AccordionContainer = () => {
  return (
    <div className="faq-section section-py">
      <div className="container">
        <div className="row">
          <div className="col-xl-10">
            <Payersolution />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionContainer;
